"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {
      fontWeight: "800",
      backgroundColor: "transparent",
      color: theme.palette.text.secondary
    },
    withoutImage: {
      borderStyle: "solid",
      borderColor: theme.palette.text.secondary
    },
    withImage: {
      border: "none"
    },
    withChildren: {},
    withoutChildren: {
      border: "none"
    },
    small: {
      width: "25px",
      height: "25px",
      fontSize: ".7rem",
      borderWidth: "1px"
    },
    medium: {
      width: "40px",
      height: "40px",
      fontSize: "1rem",
      borderWidth: "2px"
    },
    large: {
      width: "55px",
      height: "55px",
      fontSize: "1.3rem",
      borderWidth: "3px"
    },
    defaultsmall: {
      width: "25px",
      height: "25px"
    },
    defaultmedium: {
      width: "40px",
      height: "40px"
    },
    defaultlarge: {
      width: "55px",
      height: "55px"
    },
    gutterleft: {
      marginLeft: "0.25rem"
    },
    gutterright: {
      marginRight: "0.25rem"
    },
    gutterboth: {
      margin: "0 0.25rem"
    },
    gutternone: {
      margin: "0"
    }
  };
};

exports.styles = styles;